import { useCallback, useEffect } from "react";
import { RolePermission, CreateRolePermission, UpdateRolePermission } from "../types/models/RolePermission.d";
import { UpdateEntityRolePermission } from "../types/models/RolePermission";
import { useGetRolePermissionListQuery, useInsertRolePermissionMutation, useDeleteRolePermissionMutation, } from "../apis/RolePermission.api";
import { useDeleteDialog, useDescriptionAlert } from '../../share';
import { useNavigate } from "react-router";
import { t } from "@lingui/core/macro";

export default function useRolePermission(page: number, pageSize: number) {

    const navigate = useNavigate()
    const { openDialog, closeDialog } = useDeleteDialog();

    const { openSuccessAlert, openFailAlert } = useDescriptionAlert()

    const [insertRolePermissionMutation, { 
        isLoading: insertRolePermissionLoading, 
        isSuccess: insertRolePermissionIsSuccess,
        isError: insertRolePermissionIsError,
        error: insertRolePermissionError,
    }] = useInsertRolePermissionMutation()
    
    const [deleteRolePermissionMutation, { 
        isLoading: deleteRolePermissionLoading,
        isSuccess: deleteRolePermissionIsSuccess,
        isError: deleteRolePermissionIsError,
        error: deleteRolePermissionError,
    }] = useDeleteRolePermissionMutation()

    const loading =
        insertRolePermissionLoading ||
        
        deleteRolePermissionLoading ||
        false

    const insertRolePermission = useCallback(async (rolePermission: CreateRolePermission, redirectPath: string|undefined) => {
        try {
            const data = await insertRolePermissionMutation(rolePermission).unwrap()
            if (data) {
                if (redirectPath) {
                    if (redirectPath !== '.') {
                        navigate(redirectPath, {relative: 'path'})
                    }
                } else {
                    navigate(`../${data.id}`, {relative: 'path'})
                }
                return data;
            }
        } catch (e) {
            console.log("add error", e)
            openFailAlert(t`Add error: ` + e.toString())
        }
    }, [insertRolePermissionMutation, navigate])
    
    useEffect(() => {
        if (insertRolePermissionIsSuccess) {
            openSuccessAlert('Role Permission created')
        } else if (insertRolePermissionIsError) {
            console.log("add error", insertRolePermissionError)
            openFailAlert(t`Role Permission add error: ` + insertRolePermissionError?.data?.message)
        }
    }, [
        insertRolePermissionIsSuccess,
        insertRolePermissionIsError,
        insertRolePermissionError
    ]);

    

    const deleteRolePermission = useCallback((rolePermission: RolePermission, redirectPath: string|undefined) => {
        openDialog(async () => {
            rolePermission = {
                ...rolePermission,
            }
            try {
                const { data } = await deleteRolePermissionMutation(rolePermission);
                if (data != null) {
                    if (redirectPath) {
                        navigate(redirectPath, {relative: 'path'})
                    }
                }
            } catch (e) {
                console.log("delete error", e)
                openFailAlert(t`Delete error: ` + e.toString())
            }
            closeDialog()
        });
    }, [deleteRolePermissionMutation, closeDialog, openDialog])
    
    useEffect(() => {
        if (deleteRolePermissionIsSuccess) {
            openSuccessAlert(t`Role Permission deleted`)
        } else if (deleteRolePermissionIsError) {
            console.log("delete error", deleteRolePermissionError)
            openFailAlert(t`Role Permission delete error: ` + deleteRolePermissionError?.data?.message)
        }
    }, [
        deleteRolePermissionIsSuccess,
        deleteRolePermissionIsError,
        deleteRolePermissionError
    ]);

    return {
        loading,
        insertRolePermission,
        
        deleteRolePermission
    }
}
